<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          //.profile-page__header
            .profile-page__title
              h1.title Создание квоты
          .profile-page__tabs
            tab-nav(
            v-bind:tabNavData="tabNavData"
            )
          .profile-page__content
            .double-page__content
              .double-page__content-block
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Общая информация
                  .profile-section__body
                    .form
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Название квоты
                          .form-elem__body
                            input.input.input_full(
                            maxlength="50"
                            value="Спортсмены"
                            )
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Цена
                          .form-elem__body
                            input.input.input_full(
                            maxlength="50"
                            value="14000"
                            )
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Тип
                          .form-elem__main.form-elem__main_full
                            .simple-select-form
                              .simple-select-form__button Свободная продажа
                              //.simple-select-form__list
                                ul
                                  li 1
                                  li 2
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Кол-во людей
                          .form-elem__body
                            input.input.input_full(
                            maxlength="50"
                            value="15"
                            )
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Представитель оргнаизации
                          .form-elem__main.form-elem__main_full
                            .simple-select-form
                              .simple-select-form__button Эрудит
                              //.simple-select-form__list
                                ul
                                  li 1
                                  li 2
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Кол-во людей
                          .form-elem__body
                            input.input.input_full(
                            maxlength="50"
                            value="15"
                            )
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Диапазон возраста участников смены
                          .form-elem__body.form-elem__body_double
                            input.input.input_full(
                            maxlength="50"
                            value="15"
                            )
                            .separator -
                            input.input.input_full(
                            maxlength="50"
                            value="17"
                            )
                      .form__elem.form__elem_short
                        .form-elem.form-elem_horizontal
                          .form-elem__title Пол ребенка
                          .form-elem__body.radio-filter
                            .form__elem_full
                              .form-elem.form-elem_horizontal
                                label.radio
                                  input(
                                  type="radio"
                                  name="gender"
                                  checked
                                  )
                                  .radio__text Мужской
                                label.radio
                                  input(
                                  type="radio"
                                  name="gender"
                                  )
                                  .radio__text Женский

              .double-page__content-block
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Дополнительные параметры
                  .profile-section__body
                    .form
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Подтверждение льготы
                          .form-elem__main.form-elem__main_full
                            .simple-select-form
                              .simple-select-form__button Да
                              //.simple-select-form__list
                                ul
                                  li 1
                                  li 2
                    .form
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Требуются грамоты
                          .form-elem__main.form-elem__main_full
                            .simple-select-form
                              .simple-select-form__button Да
                              //.simple-select-form__list
                                ul
                                  li 1
                                  li 2
                    .form
                      .form__elem
                        .form-elem.form-elem_horizontal
                          .form-elem__title Требуется справка из школы
                          .form-elem__main.form-elem__main_full
                            .simple-select-form
                              .simple-select-form__button Да
                              //.simple-select-form__list
                                ul
                                  li 1
                                  li 2
                    section.form__elem.form__elem--align-right.form__elem_full
                      button.button.button_paint-main--transparent.button_long
                        .button__text Сохранить

            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Корпус на квоту
              .profile-section__body
                .profile__table-panel
                  .form-elem_horizontal
                    .form-elem__title Корпус
                    .simple-select-form
                      .simple-select-form__button Кирпичный 3
                      //.simple-select-form__list
                        ul
                          li Тематическая
                          li Специализированная

                  button.button.button_paint-main--transparent.button_long
                    .button__text Добавить
                .profile__table
                  quota-table(
                  :tab_data="dataTable"
                    :tab_head="headTable")

            section.form__elem.form__elem--align-justify.form__elem_full
              router-link.button.button_paint-main--transparent.button_long(
              to="/pages/director/shift/quota"
              )
                .button__text Назад
              button.button.button_paint-main.button_long
                .button__text Сохранить
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import DatePicker from "vue2-datepicker";
import SimpleSelectForm from "../../../../components/simpleSelectForm/SimpleSelectForm.vue";
import QuotaTable from "../components/quota-table.vue";

export default {
  name: "DirectorShiftsCreate",
  components: {
    QuotaTable,
    SimpleSelectForm,
    DatePicker,
    TabNav,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/director/shift/create",
            text: "Общая информация"
          },
          {
            path: "/pages/director/shift/quota",
            text: "Квоты"
          },
          {
            path: "/pages/director/shift/about",
            text: "Описание"
          },
          {
            path: "/pages/director/shift/program",
            text: "Программа"
          },
          {
            path: "/pages/director/shift/schedule",
            text: "Распорядок дня"
          },
          {
            path: "/pages/director/shift/teachers",
            text: "Педагоги"
          },
          {
            path: "/pages/director/shift/contacts",
            text: "Контакты"
          }
        ]
      },
      headTable: [
        {
          title: "Корпус",
          id: 1
        },
        {
          title: "Цена",
          id: 2
        },
        {
          title: "Вместимость",
          id: 3
        }
      ],
      dataTable: [
        {
          name: "Деревянный",
          price: "2000",
          number: "5/15",
          id: 1
        },
        {
          name: "Кирпичный 1",
          price: "2000",
          number: "10/25",
          id: 2
        },
        {
          name: "Кирпичный 2",
          price: "2000",
          number: "0",
          id: 3
        }
      ]
    };
  },
  computed: {

  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
//  computed: {
//    localDateOfBirth: {
//      get() {
//        if (!this.dateOfBirth) {
//          return "";
//        }
//        return this.dateOfBirth;
//      },
//      set() {}
//    },
//  },
//  methods: {
//    onChangeDate(date) {
//      const d = new Date(date);
//      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
//        -2
//      )}-${("0" + d.getDate()).slice(-2)}`;
//      this.$emit("onChangeValue", [_date, "date_of_birth"]);
//    },
//  }
};
</script>
